import React from "react";
import {replaceDescr} from "../../services/utils";
import SmartSearch from "../shared/SmartSearch/SmartSearch";
import BuilderSection from "../builder/BuilderDataRender";
import cls from "./site.module.scss"

function Content(props: any) {
    const {text, isTable, dbName, domain} = props;
    const data = text ? text?.data[0] : "";

    let componentsData = props?.getBuilderData?.components || {};
    let tree = props?.getBuilderData?.tree
    let initialLayout = props?.getBuilderData?.initialLayout || {}

    const drawProducts = (product: any, title: string | JSX.Element, type: string) => {
        if (title === 'builder1') {
            {
                return <BuilderSection
                    tree={tree}
                    componentsData={componentsData}
                    tab={1}
                    initialLayout={initialLayout}
                    domain={domain}
                    dbName={dbName}
                />
            }
        } else if (title === 'builder3') {
            {
                return <BuilderSection
                    tree={tree}
                    componentsData={componentsData}
                    tab={3}
                    initialLayout={initialLayout}
                    domain={domain}
                    dbName={dbName}
                />
            }
        }
    }

    return (
        <div className="block">
            <h1
                className="container"
                style={{textAlign: "center"}}
                dangerouslySetInnerHTML={{__html: data?.page_title}}
            />
            {drawProducts("builder1", "builder1", "builder")}
            <div className={`${cls.document} container`}>
                <div dangerouslySetInnerHTML={{__html: replaceDescr(data?.html_content)}}
                    // @ts-ignore
                     style={{overflowX: isTable ? "auto" : '', wordBreak: 'break-word'}}/>
            </div>
            {data?.hasShortCode &&
                <div className="container">
                    <SmartSearch
                        newSearchTitle={data?.new_search}
                        rootId={data?.shortCodeId}
                        step1Title={data?.step1_title}
                        step2Title={data?.step2_title}
                        step3Title={data?.step3_title}
                    />
                </div>
            }
            {drawProducts("builder3", "builder3", "builder")}
        </div>
    );
}

export default Content;
